import React from "react"
import { Link, graphql } from "gatsby"
import { Link as ScrollLink } from "react-scroll"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"

import _ from 'lodash'
import ogImage from "../../images/posts/56/thumb-landscape.jpg"

const Post56 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <span className="text-center">HERMES／アリーヌミニ／19 x 23 x 1cm</span>
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
            夏の軽やかなファッションに合わせて、さりげなく存在感を放つバッグを探しているなら、エルメスの「アリーヌミニ」は間違いなくおすすめです。<br></br><br></br>
            エルメスといえば、バーキンやケリーなどの名だたるアイコンバッグが有名ですが、近年、ファッショニスタの間で密かに人気を集めているのがこの<span className="text-font-bolder" style={{display: "inline", fontSize: "1.6rem"}}>『アリーヌミニ』</span>。<br></br><br></br>
            シンプルなのにエルメスらしい上質さが漂い、ほどよい抜け感で大人のコーディネートを格上げしてくれる存在感。日常使いしやすいサイズ感と気軽さも魅力で、今や隠れた名品として注目を集めています。<br></br><br></br>
            気になっている方、購入を検討している方はもちろん、エルメス好きの方にもぜひ知ってほしい「アリーヌミニ」の魅力をお届けします。<br></br><br></br>
            読み終わる頃には、あなたもきっとこの小さなバッグの虜になっていることでしょう。
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
    <section className="bag-content">
      <div className="text-two-cloumn">
        <h2 style={{color: "#0a9186"}}>目次</h2>
        <p>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec1" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>1 |</span>&nbsp;&nbsp;「アリーヌ」ってどんなバッグ？</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec2" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;〜アリーヌのはじまり〜</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec3" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;〜ミニサイズへの進化「抜け感」が叶う大人のショルダー〜</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec4" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>2 |</span>&nbsp;&nbsp;サイズ感と収納力、デザイン</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec5" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;こんな方にぴったり！</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec6" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;シンプルデザインに心惹かれる理由♡</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec7" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>3 |</span>&nbsp;&nbsp;夏のカジュアルスタイルに合わせたい理由</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec8" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;大人のリネン素材コーディネート</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec9" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;カジュアル×カラーポイントの夏コーディネート</ScrollLink><br></br>    
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec10" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>4 |</span>&nbsp;&nbsp;選ぶ楽しさが広がる、アリーヌミニの世界</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec11" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;豊富なカラーバリエーション</ScrollLink><br></br>
          </div>
          <div style={{margin: "1rem 0"}}>
            <ScrollLink className="scroll" to="sec12" smooth={true} duration={500} offset={-80} style={{fontSize: "2rem"}}><span style={{color: "#0a9186"}}>5 |</span>&nbsp;&nbsp;まとめ</ScrollLink><br></br>
            <ScrollLink className="scroll text-indent" to="sec13" smooth={true} duration={500} offset={-80}>❖&nbsp;&nbsp;「肩の力を抜いて、でも美しく。」──それがアリーヌミニの魅力</ScrollLink>
          </div>
        </p>
      </div>         
      <figure>
        <StaticImage src="../../images/posts/56/1.jpg" alt=""/>
      </figure>     
      <div name="sec1" className="text-max-width">
        <h1 className="text-color-gray">「アリーヌ」ってどんなバッグ？</h1>
        <h2 name="sec2"><span className="text-border-bottom">アリーヌのはじまり</span></h2>
      </div>
      <p className="text-max-width">エルメスの「アリーヌ（Aline）」は、その長い歴史を誇るバッグコレクションの中でも特に異彩を放ちます。その原点は、馬具を収めるための巾着袋から着想を得たとされており、1920年代にエルメスが馬具工房として名を馳せていた時代に誕生しました。余分な装飾を排したミニマルなフォルムは、当時から変わらず愛され続け、気軽に持てるデイリーバッグとして親しまれてきたのです。</p>
      <p className="text-max-width">
        このバッグが持つブランドのルーツを感じさせる素朴さと機能美は、長い年月を経ても色褪せることなく、多くの人々を魅了し続けています。<br></br>
        そして近年、現代のライフスタイルやトレンドにフィットするミニサイズが再登場したことで、アリーヌへの注目度が再燃。トレンドに敏感なファッショニスタたちがこぞって取り入れたことで、再び人気に火がつき、エルメスの新たなアイコンとしての地位を確立しています。
      </p>     
      <div name="sec3" className="text-max-width">
        <h2><span className="text-border-bottom">ミニサイズへの進化「抜け感」が叶う大人のショルダー</span></h2>       
      </div>
      <p className="text-max-width">クラシックな大きめアリーヌが時を超えて現代のファッションに溶け込む中で誕生したのが「アリーヌミニ」です。小ぶりなサイズ感と柔らかな素材は、モードにもカジュアルにもフィットし、大人のスタイルを叶えてくれます。</p> 
      <p className="text-max-width">
        余計な金具やポケットを省いた究極のミニマルデザイン。<br></br>
        それでいて、控えめなエルメスロゴがしっかりと存在感を放ちます。<br></br>
        上質なレザーの質感、エルメスのロゴが刻印された金具。<br></br>
        一切の無駄をそぎ落としたデザインだからこそ、素材のクオリティとディテールが際立ちます。<br></br>
        軽く肩にかければ、自然とこなれた雰囲気に。<br></br>
        きちんとしすぎない、それでいて品は失わない──。<br></br>
        この絶妙な「抜け感」が、大人の女性に選ばれる理由です。
      </p> 
      <figure>
        <StaticImage src="../../images/posts/56/2.jpg" alt=""/>
        <span className="text-center">荷物を入れるとこんな感じ</span>
      </figure>     
      <div name="sec4" className="text-max-width">
        <h1 className="text-color-gray">サイズ感と収納力、デザイン</h1>
      </div>
      <p className="text-max-width">
        気になるのが、実際にどれくらい入るのか。<br></br>
        「ミニバッグ」と聞くと、あまり物が入らないイメージがあるかもしれません。しかし、アリーヌミニは見た目以上に収納力があると感じる方が多いようです。<br></br>
        スマホ、ミニ財布、リップ、ハンカチ、ティシュ、エアポッズ程度なら問題なく入ります。<br></br>
        長財布は難しい場合が多いですが、キャッシュレス決済が普及した現代において、ミニ財布派の方には十分な容量と言えるでしょう。必要最低限のものをコンパクトにまとめて持ち歩きたいときに、非常に重宝するサイズ感です。
      </p>
      <div name="sec5" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ こんな方にぴったり！</span></h2>
      </div>
      <p className="text-max-width" style={{marginBottom: "6rem"}}>
        「必要最低限だけで身軽にお出かけしたい方」<br></br>
        あくまでミニサイズなので、荷物が多い人にはメインバッグとしては小さく感じるかもしれません。<br></br>
        そんなときは、メインバッグとは別にアクセサリー感覚で持つのもおしゃれです。
      </p>
      <p className="text-max-width">1、サブバッグとの組み合わせで広がる、無限のスタイリング</p>
      <p className="text-max-width">例えば、ビジネスシーンで使う大きめのトートバッグや、週末のお出かけに持つカゴバッグに、アリーヌミニを「もうひとつのバッグ」として加えてみてください。ランチタイムやちょっとした買い物に出かける際、大きなバッグはデスクや車に置いたまま、アリーヌ ミニだけをサッと持ち出すことができます。</p>
      <p className="text-max-width" style={{marginBottom: "6rem"}}>この使い方は、実用的なだけでなく、ファッションのアクセントとしても非常に効果的です。クラシックなトートバッグに鮮やかなカラーのアリーヌ ミニを添えれば、スタイル全体に軽快なリズムが生まれます。</p>
      <p className="text-max-width">2、ドレスアップシーンにも最適</p>
      <p className="text-max-width">「エルメス＝かしこまったバッグ」というイメージを覆すのが、アリーヌミニの魅力です。結婚式の二次会やホテルでの食事など、フォーマルすぎないけれど品格が求められる場面でも活躍します。チェーンバッグほど重厚にならず、さりげなく上質さをアピールできるため、ワンピースやジャケットスタイルにも自然に溶け込み、着こなしをワンランク上に引き上げてくれます。この気軽さが、2個目のエルメスとして選ばれる理由かもしれません。</p>          
      <div className="img-two-cloumn">
        <figure className="img-small">
          <StaticImage src="../../images/posts/56/3.jpg"/>
          <span className="text-center">控えめで小さめなロゴ刻印がエレガント</span>
        </figure>
        <figure className="img-small">
          <StaticImage src="../../images/posts/56/4.jpg"/>
          <span className="text-center">ショルダーの結び目がお花みたいで可愛い</span>
        </figure>
      </div>
      <div name="sec6" className="text-max-width">
        <h2><span className="text-border-bottom text-color-gray">◆ シンプルデザインに心惹かれる理由♡</span></h2>
      </div>
      <p className="text-max-width" style={{marginBottom: "6rem"}}>
        アリーヌミニのロゴは中央より若干上に小さめで刻印されています。<br></br>
        ショルダーの結び目がお花のように丁寧に縫い留めてあってシンプルで大人っぽい印象かと思えば、さりげなく可愛さもあり大人可愛い女性を演出できるかと思います。
      </p>
      <p className="text-max-width">1、削ぎ落とされたデザインが生む、不朽の美しさ</p>
      <p className="text-max-width">アリーヌミニの真骨頂は、まさにこの「引き算の美学」にあります。過度な装飾を排し、ミニマルを極めたデザインだからこそ、上質なレザーの風合い、そしてエルメスが培ってきた職人技が際立ちます。触れるたびに感じる滑らかな質感、そして使い込むほどに増す革のエイジングは、持つ喜びを一層深めてくれるでしょう。</p>
      <p className="text-max-width" style={{marginBottom: "6rem"}}>控えめなロゴは、ブランドを前面に押し出すのではなく、あくまで持つ人のスタイルに寄り添い、内から滲み出るような品格を演出します。トレンドに左右されないタイムレスな魅力は、まさに一生もの。どんなファッションにも自然と溶け込み、時代を超えて長く愛用できるバッグをお探しの方にとって、アリーヌミニはまさに理想的な選択となるはずです。</p>
      <p className="text-max-width">2、細部に込められた、エルメスの熟練技術</p>
      <p className="text-max-width">特に注目すべきは、ショルダー部分の結び目です。単なる機能的な結び目ではなく、まるで芸術作品のように丁寧に、そして美しく縫い留められています。この細部にまでこだわり抜くエルメスの熟練技術こそが、シンプルさの中に深みと特別感を与え、他のミニバッグとは一線を画す「大人のためのバッグ」としての存在感を確立しています。手にするたび、その繊細な仕事ぶりに心を奪われることでしょう。</p> 
      <div name="sec7" className="text-max-width">
        <h1>夏のカジュアルスタイルに合わせたい理由</h1>
      </div>
      <p className="text-max-width space-bottom">
        なぜアリーヌミニが夏に選ばれるのか？<br></br>
        その答えは、「軽やかさ」と「抜け感」です。<br></br>
        リネンシャツにショートパンツ、Tシャツにデニムなど、肩肘張らないコーディネートに合わせるだけで、品のある大人カジュアルが完成。また、コンパクトながら必要な荷物をすっきり収納できるので、ちょっとした街歩きや旅行のサブバッグにもぴったりです。
      </p>
      <figure name="sec8">
        <StaticImage src="../../images/posts/56/5.jpg" alt=""/>
      </figure>    
      <h2>▸ 大人のリネン素材コーディネート</h2>
      <p className="text-max-width space-bottom">
        リネンのシャツやパンツなど、涼しげな素材との相性は抜群。<br></br>
        ナチュラルな風合いのバッグだからこそ、季節感を損なわず溶け込みます。<br></br>
        まさに「肩の力を抜いて持てるエルメス」という言葉がぴったりの魅力的な夏のスタイリングです。
      </p>
      <figure name="sec9">
        <StaticImage src="../../images/posts/56/6.jpg" alt=""/>
      </figure>    
      <h2>▸ カジュアル×カラーポイントの夏コーディネート</h2>
      <p className="text-max-width space-bottom">白Tシャツとデニムの王道カジュアルスタイルに、イエローのエルメス「アリーヌミニ」を差し色として投入。ビタミンカラーが、夏の陽気さを引き立てます。軽やかなヌーディーサンダルとシルバーのアクセサリーが、都会的な抜け感を添える洗練カジュアルの好例です。</p>
      <figure>
        <StaticImage src="../../images/posts/56/7.jpg" alt=""/>
      </figure>    
      <div name="sec10" className="text-max-width">
        <h1>選ぶ楽しさが広がる、アリーヌミニの世界</h1>
        <h2 name="sec11"><span className="text-border-bottom">豊富なカラーバリエーション</span></h2>
      </div>
      <p className="text-max-width">特に注目すべきは、その豊富なカラーバリエーションです。これほど多くのカラーがあると、「どれにしよう？」と迷うのもまた楽しい時間です。季節や気分、これから出かける場所、あなたの個性を表現するのにぴったりなカラーを見つけることができます。</p>
      <p className="text-max-width">定番からトレンドまで、エルメスを象徴するエトゥープやブラックといったタイムレスなカラーはもちろん、コーディネートの主役になるような鮮やかなオレンジや心惹かれるピンク、そのシーズンのトレンドを反映した魅力的な色合いが次々と登場します。どのカラーを選んでもコーデの邪魔をしない万能さが嬉しいポイント。</p>
      <p className="text-max-width">カラー選びは洋服のテイストに合わせるのが基本ですが、迷ったらベーシックなブラウン系が一番使いやすく失敗が少ないです。</p>
      <figure>
        <StaticImage src="../../images/posts/56/8.jpg" alt=""/>
      </figure> 
      <div name="sec12" className="text-max-width">
        <h1>まとめ</h1>
        <h2 name="sec13"><span className="text-border-bottom">「肩の力を抜いて、でも美しく。」── それがアリーヌ ミニの魅力</span></h2>
      </div>   
      <p className="text-max-width">エルメスの中でもひときわ“さりげない”存在でありながら、持つ人のセンスと生き方を静かに語る「アリーヌミニ」。小ぶりながらも必要なものはしっかり収まり、どんな装いにも自然と溶け込みます。その“抜け感”と“品の良さ”はまさに大人の女性のためにあると言っても過言ではありません。</p>
      <p className="text-max-width">
        2025年の夏、ぜひ、「アリーヌミニ」を取り入れてみてはいかがでしょうか。<br></br>
        カラーで遊び、素材を楽しみ、自分らしいスタイルを完成させる一歩に。<br></br>
        迷っているなら、一度手にとってみて。
      </p>
      <p className="text-max-width">その瞬間から、きっと<span className="text-font-bolder">『後悔しない選択』</span>になるはずです。</p>
      <div className="border"></div> 
      <p className="text-max-width">📱憧れを日常に──ラクサスでエルメスを体験しよう！</p>     
      <Link to="https://laxus.co/app/pc/bags/hermes" className="view-all-button">
        エルメスのバッグはこちら
      </Link>
    </section>
    </div>
  </div>
</Layout>
)}

export default Post56

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 56}) {
      id
      title
      postId
      postedAt
      description
      categoryId
      authorId      
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
